import type { DesktopServerName } from '@dob/domain';

import { LanguageToggle, ThemeToggle } from '../../components/toggles.tsx';
import { useLang } from '../../i18n.ts';
import { ConnectionBadge } from '../../layout/ConnectionBadge.tsx';
import { useDesktopInfo } from '../../platform.ts';

/** Before sign-in: connection (so an offline sign-in failure is explained), language, theme. */
export function AuthToolbar() {
  return (
    <div className="flex flex-wrap items-center justify-end gap-2 p-4">
      <DesktopBuild />
      <div className="flex-1" />
      <ConnectionBadge />
      <LanguageToggle />
      <ThemeToggle />
    </div>
  );
}

const SERVER_LABEL = {
  staging: 'desktop.serverStaging',
  production: 'desktop.serverProduction',
  development: 'desktop.serverDevelopment',
} as const satisfies Record<DesktopServerName, string>;

/** Dob Desktop only: which version, which server, and that the build is not signed yet. */
function DesktopBuild() {
  const { t } = useLang();
  const info = useDesktopInfo();
  if (!info) return null;
  return (
    <p className="text-xs text-muted" dir="auto">
      <span dir="ltr">{t('desktop.build', { version: info.appVersion })}</span>
      {' · '}
      {t(SERVER_LABEL[info.server])}
      {info.unsigned ? ` · ${t('desktop.unsigned')}` : null}
    </p>
  );
}
